import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    ListItem,
    Popover,
    Tooltip,
    useTheme,
    Box,
} from '@material-ui/core'
import { BarChart, MoreVert, Star } from '@material-ui/icons'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import React, { useState } from 'react'
import { AvatarCircle, Container } from '../../components'
import { ApartmentVendor, ListVendor } from '../../models'
import { RateVendorDialog } from './RateVendorDialog'
import { useStyles } from '../../styles'
import { Share } from '@material-ui/icons'
import SendIcon from '@material-ui/icons/Send'
import { VendorTableRow } from './WorkforceVendorTable'
import { ListPopover } from '../../components/ListPopover/ListPopover'
import { toast } from 'react-toastify'
import { formatPhoneForDisplay } from '../../helpers'
import { useCompany } from '../../hooks'
import { ReactComponent as Logo } from '../../assets/EZ_Circle_Logo_Icon.svg'
import { Description } from '@material-ui/icons'
import AttachMoneyIcon from '@material-ui/icons/AttachMoney'
import { VendorContractsModal } from './VendorContractsModal'

interface Props {
    cellStyle: React.CSSProperties
    setEditVendor: (ven: ListVendor) => void
    setOpenDrawer: (open: boolean) => void
    row: VendorTableRow
    onClick: () => void
    setOpenAnalytics: (open: boolean) => void
    resendWelcomeEmail: (vendor: ListVendor) => void
    onClickAddVendorUser: (vendor: ListVendor) => void
    onClickRequestUpdatedPricing: (vendor: ListVendor) => void
    setOpenPricing: (open: boolean) => void
    apartmentVendor?: ApartmentVendor
    onRatingSaved?: () => void
}

export const VendorRow = (props: Props) => {
    const {
        cellStyle,
        setEditVendor,
        setOpenDrawer,
        row,
        onClick,
        setOpenAnalytics,
        resendWelcomeEmail,
        onClickAddVendorUser,
        onClickRequestUpdatedPricing,
        setOpenPricing,
        apartmentVendor,
        onRatingSaved,
    } = props

    const [openDialog, setOpenDialog] = useState(false)
    const [rateOpen, setRateOpen] = useState(false)
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null)

    const popOverOpen = Boolean(anchorEl)

    const openPopover = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const closePopover = () => {
        setAnchorEl(null)
    }

    const [openShareModal, setOpenShareModal] = useState(false)
    const [body, setBody] = useState('')
    const [subject, setSubject] = useState('')
    const [openContractModal, setOpenContractModal] = useState(false)
    const [openContractsViewModal, setOpenContractsViewModal] = useState(false)

    const [
        anchorElServices,
        setAnchorElServices,
    ] = React.useState<HTMLElement | null>(null)

    const popOverOpenServices = Boolean(anchorElServices)

    const openPopoverServices = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElServices(event.currentTarget)
    }

    const closePopoverServices = () => {
        setAnchorElServices(null)
    }

    const theme = useTheme()
    const classes = useStyles()

    const { removeVendor } = useCompany()

    function truncateWithTooltip(email: string): JSX.Element {
        if (email.length > 25) {
            return (
                <Tooltip title={email}>
                    <span>{email.slice(0, 25) + '...'}</span>
                </Tooltip>
            )
        }
        return <span>{email}</span>
    }

    return (
        <Box
            display="flex"
            key={row.vendor.id}
            style={{
                cursor: 'pointer',
                margin: theme.spacing(1, 0, 1, 0),
                border: '1px solid',
                borderColor: theme.palette.grey[400],
                borderRadius: '20px 20px 20px 20px',
                backgroundColor:
                    row.services.length !== 0
                        ? '#E5E5E5'
                        : theme.palette.grey[400],
            }}
            onClick={() => {
                if (
                    !popOverOpen &&
                    !popOverOpenServices &&
                    !openContractsViewModal &&
                    !rateOpen
                ) {
                    onClick()
                    setOpenDrawer(true)
                    setEditVendor(row.vendor)
                }
            }}
            className={classes.hoverGrey300}
        >
            {/* Avatar */}
            <Box
                display="flex"
                alignItems="flex-start"
                justifyContent="flex-start"
                style={{ flex: 1 }}
            >
                {row.vendor.profile_picture ? (
                    <AvatarCircle
                        styles={{ container: { margin: theme.spacing(1) } }}
                        image={row.vendor.profile_picture}
                    />
                ) : (
                    <AvatarCircle
                        text={row.name}
                        initials={true}
                        styles={{ container: { margin: theme.spacing(1) } }}
                    />
                )}
            </Box>
            {/* Vendor */}
            <Box
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                justifyContent="center"
                style={{ ...cellStyle, flex: 3 }}
            >
                <span>{row.name}</span>
                <span
                    style={{
                        fontSize: '0.75rem',
                        fontWeight: 400,
                        color: theme.palette.grey[600],
                        lineHeight: 1.2,
                    }}
                >
                    EZID {row.id}
                </span>
            </Box>
            {/* Address */}
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                style={{ ...cellStyle, flex: 3 }}
            >
                <span>{row.address}</span>
                <span>{`${row.vendor.city} ${row.vendor.state}, ${row.vendor.zip_code}`}</span>
            </Box>
            {/* Type */}
            <Box
                display="flex"
                alignItems="center"
                style={{ ...cellStyle, flex: 3 }}
            >
                {row.vendor.imported ? (
                    <Container
                        style={{
                            backgroundColor: 'gold',
                            borderRadius: '5px',
                            padding: theme.spacing(0.5),
                            marginRight: theme.spacing(1),
                            fontSize: '10px',
                        }}
                    >
                        Imported
                    </Container>
                ) : (
                    <Container style={{ marginLeft: theme.spacing(1) }}>
                        <Logo
                            fill={theme.palette.primary.main}
                            style={{
                                height: 25,
                                width: 25,
                                marginRight: theme.spacing(1),
                            }}
                        />
                    </Container>
                )}
                {row.type}

                {row.vendor.entrata_sync_enabled && (
                    <Container
                        style={{
                            marginLeft: theme.spacing(1),
                            fontWeight: 400,
                            fontSize: 13,
                            color: theme.palette.darkGreen.main,
                        }}
                    >
                        (Sync Ready)
                    </Container>
                )}
            </Box>
            {/* Services */}
            <Box
                display="flex"
                alignItems="center"
                style={{ ...cellStyle, flex: 3 }}
            >
                <span style={{ flex: 1 }}>
                    {createServicesString(row.vendor)}
                </span>
                {row.vendor.services.length > 3 ? (
                    <>
                        <Container>
                            <Button
                                onClick={(e) => {
                                    e.stopPropagation()
                                    openPopoverServices(e)
                                }}
                                style={{ marginRight: theme.spacing(2) }}
                            >
                                +{row.vendor.services.length - 3}
                            </Button>
                        </Container>
                        <ListPopover
                            open={popOverOpenServices}
                            anchorEl={anchorElServices}
                            onClose={closePopoverServices}
                            anchorOrigin={{
                                horizontal: -50,
                                vertical: 'bottom',
                            }}
                        >
                            {row.services.slice(3).map((service) => (
                                <ListItem key={`SERVICE_ID_${service.id}`}>
                                    {service.name}
                                </ListItem>
                            ))}
                        </ListPopover>
                    </>
                ) : (
                    <div />
                )}
            </Box>
            {/* Contact Info */}
            <Box
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                justifyContent="center"
                style={{ ...cellStyle, flex: 3 }}
            >
                <span style={{ fontWeight: 500 }}>
                    {truncateWithTooltip(row.vendor.email ?? '')}
                </span>
                <span style={{ fontWeight: 300 }}>
                    {formatPhoneForDisplay(row.vendor.phone)}
                </span>
            </Box>
            {/* Actions */}
            <Box
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
                style={{ flex: 1 }}
            >
                <Tooltip title="View Analytics">
                    <BarChart
                        fontSize="large"
                        color="action"
                        className={classes.highlightCircleOnHover}
                        onClick={(e) => {
                            e.stopPropagation()
                            setOpenAnalytics(true)
                        }}
                    />
                </Tooltip>

                <Tooltip title="View Contracts">
                    <IconButton
                        onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            setOpenContractsViewModal(true)
                        }}
                        size="small"
                        style={{ marginLeft: theme.spacing(1) }}
                    >
                        <Description />
                    </IconButton>
                </Tooltip>

                <Tooltip title="View Pricing">
                    <IconButton
                        onClick={(e) => {
                            e.stopPropagation()
                            setOpenPricing(true)
                        }}
                        size="small"
                    >
                        <AttachMoneyIcon />
                    </IconButton>
                </Tooltip>

                <Tooltip title="Rate vendor">
                    <IconButton
                        onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            setRateOpen(true)
                        }}
                        size="small"
                        style={{
                            color:
                                apartmentVendor &&
                                Number(apartmentVendor.professionalism) > 0 &&
                                Number(apartmentVendor.work_quality) > 0
                                    ? theme.palette.warning.main
                                    : undefined,
                        }}
                    >
                        <Star />
                    </IconButton>
                </Tooltip>

                <IconButton
                    onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        openPopover(e)
                    }}
                    disableRipple={true}
                    size="small"
                    style={{ marginRight: theme.spacing(1) }}
                >
                    <MoreVert />
                </IconButton>
            </Box>
            <RateVendorDialog
                open={rateOpen}
                onClose={() => setRateOpen(false)}
                title={`Rate ${row.vendor.name}`}
                vendors={[
                    {
                        id: row.vendor.id,
                        name: row.vendor.name,
                        professionalism: apartmentVendor?.professionalism,
                        work_quality: apartmentVendor?.work_quality,
                    },
                ]}
                onSaved={onRatingSaved}
            />
            <Popover
                open={popOverOpen}
                anchorEl={anchorEl}
                onClose={closePopover}
                anchorOrigin={{
                    horizontal: 'left',
                    vertical: 'bottom',
                }}
            >
                <Container
                    direction="column"
                    onClick={(e) => e.stopPropagation()}
                >
                    <IconButton
                        onClick={() => {
                            let tempBody = `${row.name}%0D${row.type}%0D${
                                formatPhoneForDisplay(row.vendor.phone) ?? ''
                            }%0D`
                            tempBody += `${row.vendor.email}%0D${
                                row.address ?? ''
                            } ${row.vendor.city ?? ''} ${
                                row.vendor.state ?? ''
                            }, ${row.vendor.zip_code ?? ''}`
                            setSubject(
                                `Here is the information about ${row.name}`,
                            )
                            setBody(tempBody)
                            setOpenShareModal(true)
                        }}
                    >
                        <Share style={{ fontSize: '17px' }} />
                        <Container
                            style={{
                                margin: theme.spacing(0, 3, 0, 1),
                                fontSize: '14px',
                            }}
                        >
                            Share
                        </Container>
                    </IconButton>

                    <IconButton
                        onClick={(e) => {
                            e.stopPropagation()
                            setOpenDialog(true)
                        }}
                    >
                        <DeleteForeverIcon style={{ fontSize: '17px' }} />
                        <Container
                            style={{
                                margin: theme.spacing(0, 3, 0, 1),
                                fontSize: '14px',
                            }}
                        >
                            Remove
                        </Container>
                    </IconButton>

                    <IconButton
                        onClick={(e) => {
                            e.stopPropagation()
                            resendWelcomeEmail(row.vendor)
                        }}
                    >
                        <Container
                            style={{
                                margin: theme.spacing(0, 3, 0, 1),
                                fontSize: '14px',
                            }}
                        >
                            Resend Welcome Email
                        </Container>
                    </IconButton>

                    <IconButton
                        onClick={(e) => {
                            e.stopPropagation()
                            onClickAddVendorUser(row.vendor)
                            closePopover()
                        }}
                    >
                        <Container
                            style={{
                                margin: theme.spacing(0, 3, 0, 1),
                                fontSize: '14px',
                            }}
                        >
                            + Add Vendor User
                        </Container>
                    </IconButton>

                    <IconButton
                        onClick={(e) => {
                            e.stopPropagation()
                            onClickRequestUpdatedPricing(row.vendor)
                            closePopover()
                        }}
                    >
                        <SendIcon style={{ fontSize: '17px' }} />
                        <Container
                            style={{
                                margin: theme.spacing(0, 3, 0, 1),
                                fontSize: '14px',
                            }}
                        >
                            Request Updated Pricing
                        </Container>
                    </IconButton>
                </Container>
            </Popover>

            <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                <DialogTitle>Remove {row.vendor.name}?</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to remove {row.vendor.name}?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        color="primary"
                        variant="outlined"
                        style={{
                            marginRight: theme.spacing(2),
                            textTransform: 'none',
                        }}
                        onClick={(e) => {
                            e.stopPropagation()
                            setOpenDialog(false)
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        color="secondary"
                        variant="contained"
                        style={{
                            marginRight: theme.spacing(2),
                            textTransform: 'none',
                        }}
                        onClick={(e) => {
                            e.stopPropagation()
                            setOpenDialog(false)
                            removeVendor({
                                body: { vendor: row.vendor.id },
                            })
                                .then(() => {
                                    e.stopPropagation()
                                    toast.success(`${row.vendor.name} Removed`)
                                })
                                .catch(() => {
                                    toast.error(
                                        `There was a problem removing ${row.vendor.name}`,
                                    )
                                })
                        }}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Vendor Contracts Modal */}
            <div onClick={(e) => e.stopPropagation()}>
                <VendorContractsModal
                    isOpen={openContractsViewModal}
                    onClose={() => setOpenContractsViewModal(false)}
                    vendor={row.vendor}
                />
            </div>
        </Box>
    )
}

export const createServicesString = (vendor: ListVendor) => {
    if (vendor.services.length >= 3) {
        return `${vendor.services[0].name}, ${vendor.services[1].name}, ${vendor.services[2].name}`
    } else if (vendor.services.length === 2) {
        return `${vendor.services[0].name}, ${vendor.services[1].name}`
    } else if (vendor.services.length === 1) {
        return `${vendor.services[0].name}`
    }
    return ''
}
